import { useDispatch } from 'react-redux';
import { CarfaxConnectUseCase } from '../../enums/CarfaxConnectUseCase';
import { HeaderService } from '../../services/shared/HeaderService';
import {
  callBackUrl,
  clientId,
  GetRefreshToken,
  IsLoggedIntoCarFax,
  RemoveAll,
} from '../../services/utils/CarFaxLocalStorage';
import { setIsLoggedIntoCarFaxAction } from '../../store/dealer/DealerActions';
import { useCarfaxAuth } from '../common/UseCarfaxAuth';

export const useUserProfileCarfax = (): UseUserProfileCarfaxType => {
  const { carFaxLogin, dispatchLoginEvent } = useCarfaxAuth();
  const dispatch = useDispatch();

  const loginCarFax = (carfaxConnectUseCase: CarfaxConnectUseCase = null) => {
    carFaxLogin(clientId(), callBackUrl());

    // after opening new tab, start an interval, which polls local storage for a value to indicate
    // whether the callback url has been called yet
    // on the callback url, wait 3 seconds and close the tab after setting the local storage value
    const interval = setInterval(() => {
      // determine if the user is logged into carfax
      if (IsLoggedIntoCarFax()) {
        // update the store if the user is logged into carfax
        dispatch(setIsLoggedIntoCarFaxAction(true));
        // dispatch the login event to the window to re-fetch snapshot keys on dealsheet and service-to-sales pages
        dispatchLoginEvent(carfaxConnectUseCase);
        // clear the interval
        clearInterval(interval);
        // clear the timeout that clears this interval
        clearTimeout(timeout);
        // use a timeout to re-wire carfax elements
        setTimeout(() => {
          // re-wire carfax elements
          (<any>window).DealerSnapshot.createDomLinks();
        }, 100);
      }
    }, 250);

    // create a timeout to clear the interval if it's still running after 20 minute (1,200,000 ms)
    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 1200000);
  };

  const logOutCarfax = (): void => {
    // get the access token
    const existingRefreshToken = GetRefreshToken();
    // revoke the access token
    HeaderService.postRevokeCarFaxAuth(clientId(), existingRefreshToken).then(() => {
      // clear all carfax localstorage values
      RemoveAll();
      // update the store
      dispatch(setIsLoggedIntoCarFaxAction(false));
      // redirect to carfax logout url
      window.open('https://auth.carfax.com/v2/logout', '_blank');
    });
  };

  return { loginCarFax, logOutCarfax };
};

type UseUserProfileCarfaxType = {
  loginCarFax: (carfaxConnectUseCase?: CarfaxConnectUseCase) => void;
  logOutCarfax: () => void;
};
